import { defineStore } from "pinia";
import { loginAdmin } from "../admin-api";

const adminTokenKey = "pet.admin.token";
const adminEmailKey = "pet.admin.email";
const adminExpiresKey = "pet.admin.expiresAt";

export const useAdminAuthStore = defineStore("adminAuth", {
  state: () => ({
    token: localStorage.getItem(adminTokenKey) || "",
    email: localStorage.getItem(adminEmailKey) || "",
    expiresAt: localStorage.getItem(adminExpiresKey) || ""
  }),
  getters: {
    isLoggedIn: (state) => Boolean(state.token && state.email)
  },
  actions: {
    async login(email: string, password: string) {
      if (!email.trim() || !password.trim()) {
        throw new Error("请输入管理员邮箱和密码。");
      }

      const response = await loginAdmin(email.trim().toLowerCase(), password);
      this.token = response.token;
      this.email = response.email;
      this.expiresAt = response.expiresAt;
      localStorage.setItem(adminTokenKey, response.token);
      localStorage.setItem(adminEmailKey, response.email);
      localStorage.setItem(adminExpiresKey, response.expiresAt);
    },
    logout() {
      this.token = "";
      this.email = "";
      this.expiresAt = "";
      localStorage.removeItem(adminTokenKey);
      localStorage.removeItem(adminEmailKey);
      localStorage.removeItem(adminExpiresKey);
    }
  }
});
